// src/App.js
import AppRoutes from "./components/router";

export default function App() {
  return (
    <div>
      <AppRoutes />  {/* routes.jsx la define pannadhu inga call panniruken */}
    </div>
  );
}
